import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22global-error.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf%22,%22variable%22:%22--font-opensansitalic%22}],%22variableName%22:%22fontOpenSansitalic%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'fontOpenSansitalic', 'fontOpenSansitalic Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
